import axios from 'axios';
import { API_REQUEST_URL, config } from './apiConfig';

const authClient = axios.create();

let refreshPromise = null;

export function exchangeCodeForTokens(code) {
  return authClient.post(`${API_REQUEST_URL}/auth/token`, {
    code,
    redirectUri: config.default.oauth.redirectSignIn,
  }).then(res => res.data);
}

export function refreshTokens(refreshToken) {
  return authClient.post(`${API_REQUEST_URL}/auth/refresh`, { refreshToken }).then(res => res.data);
}

export function refreshTokensOnce(refreshToken) {
  if (!refreshPromise) {
    refreshPromise = refreshTokens(refreshToken).finally(() => {
      refreshPromise = null;
    });
  }

  return refreshPromise;
}

